import * as ACT from '../actions/userActions';

export function user(state = {}, action) {
    switch (action.type) {


        case ACT.PERMISSION_GET_ITEM:
            return {
                ...state,
                permissionGetItem: action.data,
            };
        case ACT.PERMISSION_SET_ITEM:
            return {
                ...state,
                permissionTargetItem: action.data,
            };
        case ACT.USER_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.USER_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.USER_ADD_ITEM:
            return {
                ...state,
                addItem: action.data,
            };
        case ACT.USER_ADD_SETTLE_ITEM:
            return {
                ...state,
                addSettleItem: action.data,
            };
        case ACT.USER_ID:
            return {
                ...state,
                userId: action.data,
            };
        case ACT.ADD_COMMENT_ITEM:
            return {
                ...state,
                addCommentItem: action.data,
            };
        case ACT.GET_COMMENT_ITEM:
            return {
                ...state,
                getCommentItem: action.data,
            };
        case ACT.USER_SET_ALL:
            return {
                ...state,
                list: action.data,
            };
        case ACT.USER_SET_ALL_FOR_EXCEL:
            return {
                ...state,
                listForExcel: action.data,
            };


        case ACT.USER_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };


        case ACT.USER_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };
        case ACT.USER_STATE_RESET:
            return {
                ...state,
                state: 'none'
            };
        case ACT.USER_STATE_RECENT_ADD:
            return {
                ...state,
                state: 'recentlyAdd',
                stateTitle: action.title,
                stateMessage: action.message,
            };


        case ACT.USER_RESET_ITEM:
            return {
                ...state,
                targetItem: null,
            };


        default:
            return state
    }
};
